
angular.module('trainerWebApp.services')
  .factory('uploadService', ['$resource', 'errorHandler', function ($resource, errorHandler) {

    var resource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/parsed-upload/:token');

    return {
      getParsedUpload: function (token, resultCb, errorCb) {
        return resource.get({token: token}, resultCb, errorHandler.defaultServerErrorHandler(errorCb));
      }
    };
  }]);
